import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const hasSeenOneClickTradingModalAtom = atomWithStorage(
  "hasSeenOneClickTradingModal",
  false,
);

export const useHasSeenOneClickTradingModal = () => {
  const [hasSeenOneClickTradingModal, setHasSeenOneClickTradingModal] = useAtom(
    hasSeenOneClickTradingModalAtom,
  );

  return {
    hasSeenOneClickTradingModal,
    setHasSeenOneClickTradingModal,
  };
};
